import {
  fieldTraitTextContentOptions,
  getDataListTraits,
  getLinkDataListTraits,
  getProgressTotalListTraits,
} from './traitsApi';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const eventTypes = ['onclick', 'onmouseenter'];
  const { collections, events } = opts;

  domc.addType('text', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          tagName: 'div',
          droppable: true,
          editable: true,
          traits: [...domc.getType('text').model.prototype.defaults.traits],
        },
        init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },

      {
        isComponent: function (el) {
          if (
            el.tagName === 'LABEL' ||
            (el.tagName === 'div' && el.getAttribute('type') === 'text')
          ) {
            return { type: 'text' };
          } else {
          }
        },
      },
    ),
    view: domc.getType('text').view,
  });
  domc.addType('paragraph', {
    model: defaultModel.extend(
      {
        defaults: {
          ...domc.getType('paragraph').model.prototype.defaults,
        },
        init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el && el.tagName && el.tagName === 'P') {
            return { type: 'paragraph' };
          }
        },
      },
    ),
    view: domc.getType('paragraph').view,
  });
  domc.addType('header', {
    model: defaultModel.extend(
      {
        defaults: {
          ...domc.getType('header').model.prototype.defaults,
        },
        init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el && ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(el.tagName)) {
            return { type: 'header' };
          }
        },
      },
    ),
    view: domc.getType('header').view,
  });
  domc.addType('label', {
    model: defaultModel.extend(
      {
        defaults: {
          ...domc.getType('label').model.prototype.defaults,
        },
        init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el && el.tagName && el.tagName === 'LABEL') {
            return { type: 'label' };
          }
        },
      },
    ),
    view: domc.getType('label').view,
  });
  domc.addType('link', {
    model: defaultModel.extend(
      {
        defaults: {
          ...domc.getType('link').model.prototype.defaults,
        },
        init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
          addLinkTraitsIntoComponent(this, collections);
          addFieldsTraitOptionsIntoLink(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el && el.tagName && el.tagName === 'A') {
            return { type: 'link' };
          }
        },
      },
    ),
    view: domc.getType('link').view,
  });

  const img_src_default = 'https://drapcode-static.s3.amazonaws.com/default.png';
  const imageType = domc.getType('bs-image');
  const model = imageType.model;
  const view = imageType.view;

  domc.addType('bs-image', {
    model: model.extend(
      {
        defaults: {
          ...model.prototype.defaults,
          tagName: 'img',
          resizable: 1,
          attributes: {
            src: img_src_default,
          },
          classes: ['img-fluid'],
          traits: [
            {
              type: 'select',
              label: 'Event Type',
              name: 'eventType',
              options: [
                { id: 'onclick', name: 'On Click' },
                { id: 'onmouseenter', name: 'On Hover' },
              ],
              value: 'onclick',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Event',
              name: 'event',
              options: [],
              value: '',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Preview Icon',
              name: 'previewIcon',
              options: [
                { value: '', name: 'Show Default' },
                { value: 'smallIcon', name: 'Small Size Icon' },
                { value: 'mediumIcon', name: 'Medium Size Icon' },
                { value: 'largeIcon', name: 'Large Size Icon' },
              ],
              value: '',
              changeProp: 1,
            },
          ].concat(model.prototype.defaults.traits),
        },
        init() {
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
          const eventOptions = events.map((event) => ({
            value: event.eventName,
            name: event.eventTitle,
          }));
          this.getTrait('event').set('options', eventOptions);
          this.listenTo(this, 'change:eventType', this.updateEventType);
          this.listenTo(this, 'change:event', this.updateEvent);
          this.listenTo(this, 'change:previewIcon', this.updatePreviewIcon);
        },
        handleSelectedCollectionChange() {
          addFieldsTraitsIntoComponent(this, collections);
        },
        updateEventType() {
          const eventType = this.get('eventType');
          const attrs = this.getAttributes();
          let event = '';
          eventTypes.forEach((eventType) => {
            if (attrs[eventType]) {
              event = attrs[eventType];
              delete attrs[eventType];
            }
          });
          attrs[eventType] = event;
          this.setAttributes(attrs);
        },
        updateEvent() {
          let eventType = this.get('eventType');
          const event = this.get('event');
          const attrs = this.getAttributes();
          eventTypes.forEach((eventType) => {
            if (attrs[eventType]) delete attrs[eventType];
          });
          eventType = eventType ? eventType : 'onclick';
          attrs[eventType] = 'return ' + event + '(event)';
          this.setAttributes(attrs);
        },
        updatePreviewIcon() {
          const previewIcon = this.get('previewIcon');
          const attrs = this.getAttributes();
          attrs['data-preview-icon'] = previewIcon;
          this.setAttributes(attrs);
        },
      },
      {
        isComponent: function (el) {
          if (el && el.tagName === 'IMG') {
            return { type: 'bs-image' };
          }
        },
      },
    ),
    view: view,
  });

  domc.addType('progress-bar', {
    model: defaultModel.extend(
      {
        defaults: { ...domc.getType('progress-bar').model.prototype.defaults },
        init() {
          const attrs = this.getAttributes();
          const selectedCollection = findParentSelectedCollection(this);
          if (selectedCollection) this.handleSelectedCollectionChange();
          this.on('change:selectedCollection', this.handleSelectedCollectionChange);
          console.log('>>>>>> ProgressBar init attrs innerComponentsDataGroup', attrs);
          console.log('>>>>>> ProgressBar init this innerComponentsDataGroup', this);
        },
        handleSelectedCollectionChange() {
          addProgressBarTraitsIntoComponent(this, collections);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'progress-bar') {
            return { type: 'progress-bar' };
          }
        },
      },
    ),

    view: defaultView,
  });
}
export const addFieldsTraitsIntoComponent = async (component, collections) => {
  const selectedCollection = component.get('selectedCollection');
  const index = collections.find(
    (item) => item['collectionName'] === selectedCollection.collectionName,
  );
  if (index) {
    selectedCollection.fields = index.fields;
  }

  console.log('%c addFieldsTraitsIntoComponent', 'color:yellow', selectedCollection);
  const customType = component.get('type');
  console.log('customTypecustomType', customType);
  if (selectedCollection) {
    const trait = await getDataListTraits(customType, selectedCollection, collections);
    component.removeTrait(trait.name);
    component.addTrait(trait);
  }
};
export const addProgressBarTraitsIntoComponent = async (component, collections) => {
  const selectedCollection = component.get('selectedCollection');
  console.log('%c addProgressBarTraitsIntoComponent', 'color:yellow', selectedCollection);
  const customType = component.get('type');
  console.log('customType', customType);
  if (selectedCollection) {
    const valueTrait = getProgressTotalListTraits(customType, selectedCollection);
    const totalTrait = getProgressTotalListTraits(customType, selectedCollection, true);
    component.removeTrait(valueTrait.name);
    component.removeTrait(totalTrait.name);
    component.addTrait(valueTrait);
    component.addTrait(totalTrait);
  }
};
export const addFieldsTraitOptionsIntoLink = async (component, collections) => {
  const selectedCollection = component.get('selectedCollection');
  const traits = component.getTrait('href');
  if (selectedCollection) {
    const options = await fieldTraitTextContentOptions(selectedCollection, collections);
    traits.set({ dataGroupFieldOptions: options, collectionId: selectedCollection.collectionName });
  } else {
  }
};
export const addLinkTraitsIntoComponent = async (component, collections) => {
  const selectedCollection = component.get('selectedCollection');
  const customType = component.get('type');
  if (selectedCollection) {
    const trait = await getLinkDataListTraits(customType, selectedCollection, collections);
    component.removeTrait(trait.name);
    component.addTrait(trait);
  }
};
export const addCustomComponentType = (component) => {
  const compType = component.get('type');
  let customType = 'text';
  if (compType === 'bs-image') {
    customType = 'image';
  } else if (['image', 'select', 'checkbox', 'file-input'].includes(compType)) {
    customType = 'form-control';
  }
  component.set('custom-type', customType);
};
export const findParentSelectedCollection = (component) => {
  const dataGroup = component.closestType('data-group');
  const childDataGroup = component.closestType('child-data-group');
  const childFileDataGroup = component.closestType('child-data-group-file');
  const childDataList = component.closestType('child-data-list');
  let selectedCollection = null;
  if (childDataGroup) {
    addCustomComponentType(component);
    selectedCollection = childDataGroup.get('selectedCollectionData');
  } else if (childDataList) {
    selectedCollection = childDataList.get('selectedCollectionData');
    addCustomComponentType(component);
  } else if (childFileDataGroup) {
    console.log(
      '🚀 ~ file: innerComponents.js:298 ~ findParentSelectedCollection ~ childFileDataGroup:',
      childFileDataGroup,
    );
    // selectedCollection = dataGroup.get('selectedCollectionData');
    addCustomComponentType(component);
  } else if (dataGroup) {
    selectedCollection = dataGroup.get('selectedCollectionData');
    addCustomComponentType(component);
  }
  component.set('selectedCollection', selectedCollection);
  return selectedCollection;
};
